import fs from 'file-saver'
import {write} from 'xlsx'
export default function download(json, fileName) {
    // 获取表格头
    const headerKeys = Object.keys(json[0])
    // 需要导出数据 给 xlsx 插件的映射（也就是参数）
    const tmpData = {}
    json.forEach((temp, index) => {
        headerKeys.forEach((item, indexSon) => {
            tmpData[getCharCol(indexSon) + `${index + 1}`] = {v: temp[item]}
        })
    })

    //设置区域,比如表格从A1到D10
    let outputPos = Object.keys(tmpData);

    // xlsx 插件，生成文件所需参数
    let tmpWB = {
        SheetNames: ['mySheet'], //保存的表标题
        Sheets: {
            'mySheet': Object.assign({},
                tmpData, //内容
                {
                    '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] //设置填充区域
                })
        }
    };
    let tmpDown; //导出的内容
    const wopts = {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary'
    }
    const wbout = write(tmpWB, wopts)
    tmpDown = new Blob([s2ab(wbout)], { type: 'application/octet-stream' }); //创建二进制对象写入转换好的字节流
    fs.saveAs(tmpDown, fileName + '.xlsx');
}

function s2ab(s) { //字符串转字符流
    let buf;
    if (typeof ArrayBuffer !== 'undefined') {
        buf = new ArrayBuffer(s.length)
        let view = new Uint8Array(buf)
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
    } else {
        buf = new Array(s.length);
        for (let i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
}

function getCharCol(n) {
    let s = '',
        m = 0
    if (n === 0) s = 'A'
    while (n > 0) {
        m = n % 26 + 1
        s = String.fromCharCode(m + 64) + s
        n = (n - m) / 26
    }
    return s
}

// 手动实现
// function saveAs(obj, fileName) { //导出功能实现
//     let tmpa = document.createElement("a");
//     tmpa.download = fileName || "下载";
//     tmpa.href = URL.createObjectURL(obj); //绑定a标签
//     tmpa.click(); //模拟点击实现下载
//     setTimeout(function () { //延时释放
//         URL.revokeObjectURL(obj); //用URL.revokeObjectURL()来释放这个object URL
//     }, 100);
// }